
import React from "react";

interface LoadingSpinnerProps {
  className?: string;
}

export function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div className={`flex flex-col items-center justify-center ${className || ""}`}>
      <div className="flex space-x-2">
        <div className="animate-bounce rounded-full bg-black h-3 w-3 delay-0"></div>
        <div className="animate-bounce rounded-full bg-black h-3 w-3 delay-150"></div>
        <div className="animate-bounce rounded-full bg-black h-3 w-3 delay-300"></div>
      </div>
    </div>
  );
}
